import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './globals.css'
import { injectThemeVariables } from './utils/theme'

// Inject theme variables from .env before rendering
injectThemeVariables();

// Debug: Log env variable to verify it's loaded
console.log('🔍 DEBUG - VITE_LOGIN_BG_LEFT:', import.meta.env.VITE_LOGIN_BG_LEFT);
console.log('🔍 DEBUG - Type:', typeof import.meta.env.VITE_LOGIN_BG_LEFT);
console.log('🔍 DEBUG - Length:', import.meta.env.VITE_LOGIN_BG_LEFT?.length);
console.log('🔍 DEBUG - VITE_BRAND_COLOR:', import.meta.env.VITE_BRAND_COLOR);
console.log('🔍 DEBUG - All VITE_ keys count:', Object.keys(import.meta.env).filter(k => k.startsWith('VITE_')).length);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)